import * as crypto from "crypto-js";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import Loader from "../../../components/Loader/Loader";
import UserService from "../../../services/UserService";
import "./FormUsers.css";
import DualList from "../../../components/DualList/DualList/DualList";
import PolicyService from "../../../services/PoliciesService";
import { useAuth } from "../../../contexts/auth";
import RoleService from "../../../services/RolesService";
import GroupService from "../../../services/GroupsService";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import Modal from "react-modal";
import Button from "../../../components/Button/Button";
import { TbUserShield } from "react-icons/tb";
import { PoliciesDDL } from "../../../components/PoliciesDDL/PoliciesDDL";
import { GroupsDDL } from "../../../components/GroupsDDL/GroupsDDL";
import { RolesDDL } from "../../../components/RolesDDL/RolesDDL";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--containerBackgroundColor)",
	},
};

function FormUsers(props) {
	const { user } = useAuth();
	const [name, setNome] = useState(props.user?.name);
	const [email, setMail] = useState(props.user?.email);
	const [confirmNewPassword, setConfirmNewPassword] = useState();
	const [newPassword, setNewPassword] = useState();
	const [showLoader, setShowLoader] = useState(false);
	const [showChangePassword, setShowChangePassword] = useState(false);
	const [isSuperAdmin, setIsSuperAdmin] = useState(props.user?.isSuperAdmin);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [allPolicies, setAllPolicies] = useState([]);
	const [selectedPolicies, setSelectedPolicies] = useState([]);
	const [notSelectedPolicies, setNotSelectedPolicies] = useState([]);
	const [password, setPassword] = useState("");
	const [allRoles, setAllRoles] = useState([]);
	const [selectedRoles, setSelectedRoles] = useState([]);
	const [notSelectedRoles, setNotSelectedRoles] = useState([]);

	const [allGroups, setAllGroups] = useState([]);
	const [selectedGroups, setSelectedGroups] = useState([]);
	const [notSelectedGroups, setNotSelectedGroups] = useState([]);

	const clientData = user.userData.selectedOrganizationId;

	useEffect(() => {
		setNome(props.user?.name);
		setMail(props.user?.email);
		setIsSuperAdmin(props.user?.isSuperAdmin);
		setSelectedPolicies(props.user?.policies || []);
		setSelectedRoles(props.user?.roles || []);
		setSelectedGroups(props.user?.groups || []);
	}, [props.user]);

	const navigate = useNavigate();

	const buildPayload = () => {
		let payload = {
			name: name,
			email: email,
			policies: selectedPolicies?.map(selectedPolicy => selectedPolicy.value),
			roles: selectedRoles?.map(selectedRole => selectedRole.value),
			groups: selectedGroups?.map(selectedGroup => selectedGroup.value),
			isSuperAdmin,
			password,
		};
		if (showChangePassword && newPassword) {
			payload.senha = crypto.SHA256(newPassword).toString();
		}
		return payload;
	};

	async function handleSubmit(event) {
		event.preventDefault();
		if (isSuperAdmin && isSuperAdmin !== props.user?.isSuperAdmin) {
			setModalIsOpen(true);
			return;
		}
		submit();
	}

	async function submit() {
		if (confirmNewPassword !== newPassword) {
			NotificationManager.error("", "Senhas não são iguais", 3000, () => {
				alert("callback");
			});
			return;
		}
		setShowLoader(true);
		const payload = buildPayload();
		const response = await UserService.updateUser(props.user.id, payload);
		setShowLoader(false);
		if (!response.data.id) return;
		navigate("../consulta-users", {
			state: { refresh: true }
		});
	}

	const handleClickEditButton = () => {
		if (!props.user) return;
		navigate(`/users/${props.user.externalId}`, { state: props.user });
	};

	const handleDualList = (notSelected, selected) => {
		setSelectedPolicies(selected);
		setNotSelectedPolicies(notSelected);
	};

	const handleRoleDualList = (notSelected, selected) => {
		setSelectedRoles(selected);
		setNotSelectedRoles(notSelected);
	};

	const handleGroupDualList = (notSelected, selected) => {
		setSelectedGroups(selected);
		setNotSelectedGroups(notSelected);
	};

	function handleCancel() {
		setModalIsOpen(false);
	}

	return (
		<React.Fragment>
			<FormTitle
				type={props.type}
				icon={<TbUserShield size={20} />}
				tituloConsulta={props.user?.nome || null}
				tituloCadastro="Edição de Usuários Cloud"
				backRoute={"/consulta-users"}
			/>
			{showLoader ? (
				<Loader />
			) : (
				<Form
					handleSubmit={handleSubmit}
					type={props.type}
					handleClickEdit={handleClickEditButton}
					navigateCancelUrl="../consulta-users"
				>
					<div className="grid grid-cols-2 gap-3 w-full">
						<Input
							name="name"
							id="name"
							labelText="Nome *"
							value={name}
							onChange={({ target }) => setNome(target.value)}
							disabled={true}
							required={true}
						/>
						<Input
							name="mail"
							id="mail"
							labelText="Email *"
							value={email}
							onChange={({ target }) => setMail(target.value)}
							disabled={true}
							required={true}
						/>
					</div>
					{props.type !== "consulta" && user.userData.isSuperAdmin && !user.userData.selectedOrganizationId && (
						<ToggleButton
							style={{ justifyContent: 'start' }}
							label={`${isSuperAdmin
								? "Super Administrador Habilitado"
								: "Super Administrador Desabilitado"
								}`}
							selected={isSuperAdmin}
							onClick={() => setIsSuperAdmin(!isSuperAdmin)}
							disabled={props.type === "consulta"}
							tooltipVisible={true}
							tooltipText={
								"Habilita ou desabilita o acesso como super administrador, com essa habilidade o usuário tem acesso completo ao sistema."
							}
						/>
					)}
					{props.type !== "consulta" && !isSuperAdmin && (
						<>
							<div className="form-cond-dual-list-container w-full">
								{/* <DualList
									data={allRoles?.map(role => ({
										label: role.name,
										value: role.id,
									}))}
									notSelected={notSelectedRoles}
									alreadySelected={selectedRoles}
									onChange={(notSelected, selected) =>
										handleRoleDualList(notSelected, selected)
									}
									labelLeft="Perfis Disponíveis"
									labelRight="Perfis Selecionadas"
								/> */}
								<RolesDDL
									onChangeList={handleRoleDualList}
									roles={selectedRoles}
								/>
							</div>
							<div className="form-cond-dual-list-container w-full">
								<GroupsDDL
									onChangeList={handleGroupDualList}
									groups={selectedGroups}
								/>
							</div>
							<div className="form-cond-dual-list-container w-full">
								<PoliciesDDL
									onChangeList={handleDualList}
									policies={selectedPolicies}
								/>
							</div>
						</>
					)}
				</Form>
			)}
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={handleCancel}
					style={customStyles}
					contentLabel="Modal"
					ariaHideApp={false}
				>
					<div className="modal-content-container">
						<h1 className="modal-text">Tem certeza que deseja transformar esse usuário em um super administrador?</h1>
						<React.Fragment>
							<p className="delete-button-modal-text">
								Este usuário após receber essa habilidade terá permissão de acessar e manipular qualquer área do sistema!
							</p>
							<p className="delete-button-modal-text">
								Para continuar, confirme suas credenciais:
							</p>
							<Input
								name="password"
								id="password"
								placeholder="Digite sua senha"
								value={password}
								type="password"
								autoComplete="off"
								onChange={({ target }) => setPassword(target.value)}
								required={true}
							/>
						</React.Fragment>
						<div className="modal-buttons-container">
							<Button onClick={submit} label="Sim"></Button>
							<Button
								className={"button-white"}
								onClick={handleCancel}
								label="Cancelar"
							></Button>
						</div>
					</div>
				</Modal>
			)}
		</React.Fragment>
	);
}

export default FormUsers;
